//WORKSPACE
export const WSADMIN = 'WSADMIN';
export const WSUSER = 'WSUSER';
export const wsAllAccess = [WSADMIN, WSUSER]
export const wsAdminOnlyAccess = [WSADMIN];

//SKETCH (Drawout Lite)
export const SKUSER = 'SKUSER';
export const skAllAccess = [SKUSER];

//TESTSPACE
export const TSADMIN = 'TSADMIN';
export const TSUSER = 'TSUSER';
export const TSTESTER = 'TSTESTER';
export const tsAllAccess = [TSADMIN, TSUSER, TSTESTER];
export const tsAdminAccess = [TSADMIN, TSUSER];
export const tsAdminOnlyAccess = [TSADMIN];
export const tstesterAccess = [TSTESTER];

//ZEN CONFIGURATION
export const ZCADMIN = 'ZCADMIN';
export const ZCUSER = 'ZCUSER';
export const zcAllAccess = [ZCADMIN, ZCUSER];